/* assets/sanitize-site.js */
(function () {
  // --- Replace / remove sets ---
  const RE_SPACES_TO_SPACE = /[\u00A0\u1680\u180E\u2000-\u200B\u202F\u205F\u3000\u2800\u3164\uFFA0]/g;
  const RE_ZW_TO_SPACE     = /[\u200C\u200D]/g;
  const RE_REMOVE          = /[\u00AD\u034F\u200E\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\u115F\u1160\u17B4\u17B5\u180B-\u180D\uFE00-\uFE0F\uFEFF]/g;
  const RE_LINE_SEP        = /\u2028/g;    // → \n
  const RE_PARA_SEP        = /\u2029/g;    // → \n\n
  const RE_CR              = /\r/g;
  const RE_FF              = /\f/g;
  const RE_SMART_DQ        = /[“”]/g;      // → "
  const RE_SMART_SQ        = /[‘’]/g;      // → '
  const RE_ELLIPSIS        = /\u2026/g;    // → ...
  const RE_MANY_SPACES     = /[ \t\u00A0]{2,}/g; // collapse 2+ spaces
  const RE_SPACE_AROUND_NL = /[ \t]*\n[ \t]*/g;  // trim around newlines

  // Replace <br> tags with plain spaces so sanitizer can normalize
  function stripBreaksIn(el) {
    if (!el) return;
    // Only target product descriptions and explicit opt-in elements
    const targets = el.matches?.('.product__description,[data-sanitize-br="strip"]')
      ? [el]
      : el.querySelectorAll?.('.product__description, [data-sanitize-br="strip"]');

    (targets || []).forEach(root => {
      // Replace all <br> (any form) with a single space text node
      root.querySelectorAll('br').forEach(br => {
        br.replaceWith(document.createTextNode(' '));
      });
      // Also collapse stray <br> strings that might exist in innerHTML (edge apps)
      if (root.innerHTML && /<br\s*\/?>/i.test(root.innerHTML)) {
        root.innerHTML = root.innerHTML.replace(/(<br\s*\/?>\s*)+/gi, ' ');
      }
    });
  }

  function cleanText(s) {
    if (!s) return s;
    s = s
      .replace(RE_SPACES_TO_SPACE, ' ')
      .replace(RE_ZW_TO_SPACE, ' ')
      .replace(RE_REMOVE, '')
      .replace(RE_LINE_SEP, '\n')
      .replace(RE_PARA_SEP, '\n\n')
      .replace(RE_CR, '')
      .replace(RE_FF, '')
      .replace(RE_SMART_DQ, '"')
      .replace(RE_SMART_SQ, "'")
      .replace(RE_ELLIPSIS, '...')
      .replace(RE_MANY_SPACES, ' ')
      .replace(RE_SPACE_AROUND_NL, '\n')
      .trim();
    return s;
  }

  function shouldSkip(el) {
    return (
      !el ||
      el.closest('script,style,textarea,code,pre,svg,math') ||
      el.closest('[data-sanitize="off"]') ||
      (el.nodeType === 1 && getComputedStyle(el).visibility === 'hidden')
    );
  }

  function sanitizeRoot(root) {
    // Pre-pass: remove <br> in targeted areas so spacing normalizes
    stripBreaksIn(root);

    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(n) {
          const p = n.parentElement;
          if (!p || shouldSkip(p)) return NodeFilter.FILTER_REJECT;
          const v = n.nodeValue;
          if (!v || !v.trim()) return NodeFilter.FILTER_REJECT;
          // Only visit if any non-ASCII chars are present
          return /[^\u0009\u000A\u000D\u0020-\u007E]/.test(v)
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_REJECT;
        }
      }
    );

    let node;
    while ((node = walker.nextNode())) {
      const cleaned = cleanText(node.nodeValue);
      if (cleaned !== node.nodeValue) node.nodeValue = cleaned;
    }
  }

  function schedule(fn) {
    if ('requestIdleCallback' in window) return requestIdleCallback(fn, { timeout: 500 });
    return setTimeout(fn, 0);
  }

  function boot() {
    // Initial pass
    schedule(() => sanitizeRoot(document.body));

    // Re-run when Shopify sections re-render
    document.addEventListener('shopify:section:load', e => sanitizeRoot(e.target));
    document.addEventListener('shopify:section:select', e => sanitizeRoot(e.target));

    // Observe dynamic content
    const mo = new MutationObserver(muts => {
      for (const m of muts) {
        for (const n of m.addedNodes) {
          if (n.nodeType === 1 && !shouldSkip(n)) {
            schedule(() => sanitizeRoot(n));
          } else if (n.nodeType === 3) {
            const p = n.parentElement;
            if (p && !shouldSkip(p)) {
              const cleaned = cleanText(n.nodeValue);
              if (cleaned !== n.nodeValue) n.nodeValue = cleaned;
            }
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();